import type { NuxtApp } from '#app'
import { pendingIdentityLoads } from '~/utils/pendingIdentityLoads'
import { sanctumTokenStorage } from '~/utils/sanctumTokenStorage'

const readToken = async (nuxtApp: NuxtApp): Promise<string | undefined> => {
  try {
    return await sanctumTokenStorage.get(nuxtApp)
  } catch {
    return undefined
  }
}

// Fresh reads wait for earlier mutations to settle; join callers share the queue tail.
export const refreshStoredIdentity = async (
  nuxtApp: NuxtApp,
  refreshIdentity: () => Promise<void>,
  mode: 'fresh' | 'join' = 'join'
): Promise<void> => {
  if ((await readToken(nuxtApp)) === undefined) return

  const tail = pendingIdentityLoads.get(nuxtApp)
  if (tail !== undefined && mode === 'join') return tail

  const step: Promise<void> =
    tail === undefined
      ? refreshIdentity()
      : tail
          .catch(() => undefined)
          .then(async () => {
            if ((await readToken(nuxtApp)) === undefined) return
            await refreshIdentity()
          })
  const link: Promise<void> = step.finally(() => {
    if (pendingIdentityLoads.get(nuxtApp) === link) pendingIdentityLoads.delete(nuxtApp)
  })
  pendingIdentityLoads.set(nuxtApp, link)
  return link
}
